enum SessionStartAction {
  NoAction = 'no-action',
  Swipe = 'swipe',
  Start = 'start',
  StartDelphiConsent = 'start-delphi-consent',
  StartDelphiOptOut = 'start-delphi-opt-out',
}

export default SessionStartAction;
